import script from "./bulk-data-download-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./bulk-data-download-panel.vue?vue&type=script&setup=true&lang=js"

import "./bulk-data-download-panel.vue?vue&type=style&index=0&id=5b9a4256&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9a4256"]])

export default __exports__